// Port of api/fuel/app/classes/insights/records/stats.php

import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Constants from 'offline/constants'

function packageStats(segment, stats, detail, statType) {
	var limit = detail ? 100 : 5
	var items = Util.sort_by_field(stats[statType] || [], 'count', 'desc').slice(0, limit)

	for (var i = 0; i < items.length; i++) {
		segment._references.users.push(parseInt(items[i].user, 10))
		items[i].games = (items[i].games || []).slice(0, 10)
		for (var j = 0; j < items[i].games.length; j++) {
			segment._references.games.push(parseInt(items[i].games[j], 10))
		}
	}

	return items
}

export default Segment.extend({
	name: 'stats',
	types: [Constants.TYPE_USER],
	requires: ['init'],
	insight: false,
	methods: {
		records_stats_analysis: function(type, owner, userIndex) {
			var stats = { day: [], new: [] }
			var plays = this._data.plays || []

			if (!plays.length) return stats

			var currentDate = {}
			var currentDayStat = {}
			var currentNewStat = {}
			var gamesPlayed = {}

			for (var i = 0; i < userIndex.length; i++) {
				var userId = userIndex[i]
				currentDate[userId] = 0
				currentDayStat[userId] = { user: userId, plays: [], games: [], date: 0, count: 0 }
				currentNewStat[userId] = { user: userId, plays: [], games: [], date: 0, count: 0 }
				gamesPlayed[userId] = []
			}

			for (var p = 0; p < plays.length; p++) {
				var play = plays[p]
				var uid = play.user

				if (currentDate[uid] !== play.date && currentDate[uid] !== 0) {
					if (currentNewStat[uid].count) stats.new.push(currentNewStat[uid])
					stats.day.push(currentDayStat[uid])

					currentNewStat[uid] = { user: uid, plays: [], games: [], count: 0, date: 0 }
					currentDayStat[uid] = { user: uid, plays: [], games: [], count: 0, date: 0 }
				}

				currentNewStat[uid].date = parseInt(play.date, 10)
				currentDayStat[uid].date = parseInt(play.date, 10)
				currentDayStat[uid].plays.push(parseInt(play.play, 10))
				currentDayStat[uid].games.push(parseInt(play.game, 10))
				currentDayStat[uid].count += parseInt(play.count, 10)

				if (gamesPlayed[uid].indexOf(play.game) === -1) {
					currentNewStat[uid].count++
					currentNewStat[uid].plays.push(parseInt(play.play, 10))
					currentNewStat[uid].games.push(parseInt(play.game, 10))
					gamesPlayed[uid].push(play.game)
				}

				currentDate[uid] = play.date
			}

			for (var u = 0; u < userIndex.length; u++) {
				var userKey = userIndex[u]
				if (currentNewStat[userKey].count) stats.new.push(currentNewStat[userKey])
				if (currentDayStat[userKey].count) stats.day.push(currentDayStat[userKey])
			}

			return stats
		}
	},
	run: function(type, owner, userIndex, detail, filter, vars) {
		var stats = this.records_stats_analysis(type, owner, userIndex)

		if (detail) {
			stats = packageStats(this, stats, detail, vars.statType)
		} else {
			stats = {
				new: packageStats(this, stats, detail, 'new'),
				day: packageStats(this, stats, detail, 'day')
			}
		}

		this._data.stats = stats

		return {
			stats: stats
		}
	}
})
